import { Logger } from '@/utils/logging';

const hasWindow = typeof window !== 'undefined';

const hasPlatformParam =
  hasWindow &&
  new URLSearchParams(window.location.search).get('platform') === 'widget';

const isEmbedded = hasWindow && window.self !== window.parent;

// SQR-13814: the worker forwards `platform=widget` unchanged, so a pasted
// iframe URL (param, no frame) or a foreign framing host (frame, no param)
// must not be treated as the widget. Both signals are required.
export const isWidget: boolean = hasPlatformParam && isEmbedded;

export const widgetEntryHref: string | undefined = hasWindow
  ? window.location.href
  : undefined;

export const logWidgetDetectionMismatch = (): void => {
  if (hasPlatformParam === isEmbedded) return;
  Logger.warn('widget_detection_mismatch', { hasPlatformParam, isEmbedded });
};
